import { render, staticRenderFns } from "./formAngariacaoExterna.vue?vue&type=template&id=4d8ac004&scoped=true"
import script from "./formAngariacaoExterna.vue?vue&type=script&lang=js"
export * from "./formAngariacaoExterna.vue?vue&type=script&lang=js"
import style0 from "./formAngariacaoExterna.vue?vue&type=style&index=0&id=4d8ac004&prod&lang=scss"
import style1 from "./formAngariacaoExterna.vue?vue&type=style&index=1&id=4d8ac004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8ac004",
  null
  
)

export default component.exports